<template>
  <v-app-bar app>
    <v-toolbar-title class="mx-8">Document Comparison</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn :to="'tasks'" text>Task List</v-btn>
    <v-btn :to="'new-task'" text>New Task</v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'TaskHeader',
}
</script>
